import React from 'react';

const rowWrapSpcBtween = (): React.CSSProperties => {
  return {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap', // allows wrapping to new lines
    justifyContent: 'start',
  };
};

export default rowWrapSpcBtween;
